<template>
  <div v-loading="loading" style="padding: 10px; height: 100%">
    <div class="left">
      <!-- <el-page-header
        @back="goBack"
        :content="schoollist.name + '：观测点'"
      ></el-page-header> -->

      <el-table
        :data="tableData"
        border
        stripe
        :span-method="objectSpanMethod"
        style="width: 100%; margin-top: 15px"
        highlight-current-row
      >
        <!-- <el-table-column type="index" align="center"></el-table-column> -->
        <el-table-column
          prop="nodeName"
          label="所属维度"
          align="center"
          width="120"
        ></el-table-column>
        <el-table-column
          prop="courseName"
          label="课程名称"
          align="center"
          width="120"
        ></el-table-column>
        <el-table-column
          label="课程目标"
          align="center"
          prop="leafName"
          width="180"
        ></el-table-column>
        <el-table-column label="关键行为" align="center">
          <template slot-scope="scope">
            <div class="left">
              {{ scope.row.pointContent }}
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column label="操作" align="center" width="120">
          <template slot-scope="scope">
            <el-button type="text">编辑</el-button>
          </template>
        </el-table-column> -->
        <el-table-column label="操作" align="center" width="280">
          <template slot-scope="scope">
            <el-button type="text" @click="editKeyPoints(scope.row)"
              >编辑</el-button
            >
            <el-button type="text" @click="selectCourseActionStore(scope.row)"
              >从库里选择</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page.sync="curPage"
        style="margin-top: 15px"
        @prev-click="gai"
        @next-click="gai"
        @current-change="gai"
        background
        layout="total,prev, pager, next"
        :hide-on-single-page="true"
        :total="total"
      ></el-pagination>
      <div class="btns df jc-e">
        <div class="add_calss df ai-c" v-if="courseOfferingStatus">
          如需其他课程，您可前往<el-link
            type="danger"
            :underline="false"
            @click="goClass"
            >课程开展</el-link
          >添加
        </div>
        <el-button size="mini" plain type="primary" @click="handlePreOrNext(1)"
          >上一步:{{
            progressStatusList[1] && progressStatusList[1].progressItemName
          }}</el-button
        >
        <el-button
          size="mini"
          plain
          type="primary"
          @click="handlePreOrNext(3)"
          v-if="!isLast"
          >下一步:{{
            progressStatusList[3] && progressStatusList[3].progressItemName
          }}</el-button
        >
        <el-button
          size="mini"
          plain
          type="primary"
          @click="handlePreOrNext(3)"
          v-else
          >完成</el-button
        >
      </div>
    </div>
    <el-dialog
      title="选择行为"
      :visible.sync="dialogVisible5"
      width="800px"
      class="left"
    >
      <el-tree
        :data="tableData2"
        ref="tree"
        check-strictly
        show-checkbox
        default-expand-all
        node-key="id"
        highlight-current
        :props="defaultProps"
        @check="dianjisdf"
      ></el-tree>
      <!--<el-checkbox v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>-->
      <!-- <el-checkbox-group v-model="checkList">
				<div v-for="list in tableData2" :key="list.id">
					<el-checkbox :label="list.id" disabled>{{list.nodeName}}</el-checkbox>
					<div v-for="data in list.childs" :key="data.id" style="margin-left: 25px;">
						<el-checkbox :label="list.id" disabled>{{data.nodeName}}</el-checkbox>
						<div v-for="item in data.pointList" :key="item.nodeName" style="margin-left: 25px;">
							<el-checkbox :label="item.id">{{item.nodeName}}</el-checkbox>
						</div>
					</div>
				</div>
			</el-checkbox-group> -->
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible5 = false"
          >取 消</el-button
        >
        <el-button size="small" type="primary" @click="getCheckedKeys"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog title="从库里选择" :visible.sync="dialogVisible2" width="600px">
      <el-steps :active="active" finish-status="success">
        <el-step title="选行为"></el-step>
        <el-step title="选目标"></el-step>
      </el-steps>
      <div v-if="active == 0">
        <el-checkbox-group v-model="checkListsd">
          <div v-for="(list, index) in xinglist" :key="index">
            <el-checkbox :label="list.id">{{ list.pointContent }}</el-checkbox>
          </div>
        </el-checkbox-group>
        <div style="margin: 15px 0; text-align: right">
          <el-button
            type="primary"
            plain
            size="small"
            :disabled="checkListsd.length == 0"
            @click="xiayibu"
            >下一步</el-button
          >
        </div>
      </div>
      <div v-if="active == 1">
        <div
          v-for="(list, index) in xuanlists"
          :key="index"
          style="margin-bottom: 10px"
        >
          <el-row :gutter="10">
            <el-col :span="16">
              <el-input
                v-model="list.pointContent"
                disabled
                placeholder="请输入内容"
                size="mini"
              ></el-input>
            </el-col>
            <el-col :span="8">
              <el-cascader
                size="mini"
                v-model="list.nodeid"
                :show-all-levels="false"
                :options="nodeTlist"
                :props="{ checkStrictly: false }"
              ></el-cascader>
            </el-col>
          </el-row>
        </div>
        <div style="margin: 15px 0; text-align: right">
          <el-button type="primary" plain size="small" @click="active = 0"
            >上一步</el-button
          >
          <el-button
            type="primary"
            plain
            size="small"
            @click="insertCourseAction"
            >保存</el-button
          >
        </div>
      </div>
    </el-dialog>
    <el-dialog
      title="导入课程行为"
      :visible.sync="dialogVisible1"
      width="30%"
      style="text-align: left"
    >
      <div>
        1、请先下载模板
        <el-button
          type="text"
          style="float: right; padding: 0"
          @click="curriculumManagedownloadtemplate"
          >下载模板</el-button
        >
      </div>
      <div style="margin: 10px 0">2、模板填写完成上传提交</div>
      <el-upload
        class="upload-demo"
        ref="upload"
        :headers="headers"
        :data="dataw"
        :on-success="chengg"
        @click.native="shangchaun()"
        :action="urlslist()"
        :file-list="fileList"
        :auto-upload="false"
      >
        <el-button slot="trigger" size="small" type="primary"
          >导入课程行为</el-button
        >
      </el-upload>
      <span slot="footer" class="dialog-footer">
        <el-button
          @click=";(dialogVisible1 = false), (dialogVisible6 = false)"
          size="small"
          >取 消</el-button
        >
        <el-button type="primary" @click="submitUpload" size="small"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      class="youcedigao"
      top="0"
      :modal="false"
      title="导入结果统计"
      :visible.sync="dialogVisible6"
      width="30%"
      style="text-align: left"
    >
      <el-row id="ID">
        <el-col :span="24" style="font-weight: bold; margin-bottom: 10px">
          成功信息
        </el-col>
        <el-col :span="24"> 成功导入 {{ dats.scount }} 条 </el-col>
        <el-col :span="24" style="font-weight: bold; margin-top: 10px">
          失败信息
        </el-col>
        <el-col :span="24">
          <el-table
            :data="dats.errorMsgs"
            border
            stripe
            style="width: 100%; margin-top: 15px"
            highlight-current-row
          >
            <el-table-column
              prop="row"
              label="错误行数"
              align="center"
              width="100"
            ></el-table-column>
            <el-table-column
              prop="msg"
              label="错误信息"
              align="center"
            ></el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </el-dialog>
    <el-dialog title="编辑" :visible.sync="editDialogVisible" width="600px">
      <div class="tips_text">
        提示:行为字数小于18个字，超过该字数算新的一行，整个课程下不能超过9行
      </div>
      <el-form :model="formData" ref="ruleForm" class="demo-ruleForm">
        <div
          v-for="(list, index) in formData.editList"
          :key="index"
          style="margin-bottom: 10px"
        >
          <el-row :gutter="10">
            <el-col :span="15">
              <el-form-item
                :prop="'editList.' + index + '.pointContent'"
                :rules="{
                  required: true,
                  message: '行为不能为空',
                  trigger: 'blur',
                }"
              >
                <el-input
                  v-model="list.pointContent"
                  placeholder="请输入内容"
                  style="width: 100%"
                  size="mini"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item
                :prop="'editList.' + index + '.templateDetailId'"
                :rules="{
                  required: true,
                  message: '请选择课程目标',
                  trigger: 'blur',
                }"
              >
                <el-cascader
                  size="mini"
                  v-model="list.templateDetailId"
                  :show-all-levels="false"
                  ref="cascaderref"
                  style="width: 100%"
                  :options="nodeTlist"
                  :props="{ checkStrictly: false, emitPath: false }"
                  @change="handleChange($event, index)"
                ></el-cascader>
              </el-form-item>
            </el-col>
            <el-col :span="2">
              <el-form-item>
                <el-button
                  type="danger"
                  icon="el-icon-delete"
                  size="mini"
                  circle
                  @click="delItem(index)"
                ></el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>

      <div style="margin: 20px 0; text-align: right">
        <!-- <el-button type="primary" plain size="small" @click="active = 0"
            >添加自定义行为</el-button
          > -->
        <el-button
          type="primary"
          size="mini"
          icon="el-icon-plus"
          @click="addBehavior"
          >添加自定义行为</el-button
        >
        <el-button type="primary" plain size="mini" @click="editSave"
          >保存</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as homeApi from '@/api/observation'
import {
  getSchoolTemplateMsg,
  saveCourseBehaviorAndTarget,
  saveCourseObservations,
  usercenterinfo,
  getMyappList,
  getSchoolConfigStep,
} from '@/api/home'
import { BASE_URL, BASE_URLLIST } from '@/api/index'
import resetMessage from '@/assets/js/resetMessage'
export default {
  components: {},
  data() {
    return {
      loading: false,
      active: 0,
      curPage: 1,
      loadings: false,
      tableData: [],
      spanArr: [],
      pos: 0,
      spanArr1: [],
      pos1: 0,
      spanArr2: [],
      pos2: 0,
      courseId: '',
      dialogVisible: false,
      dialogVisible1: false,
      dialogVisible2: false,
      dialogVisible5: false,
      editDialogVisible: false, //编辑弹窗flag
      ruleForm: {
        cardBack: '',
        cardFront: '',
        centerImg: '',
      },
      urls: BASE_URLLIST + '/evaluate/file/oss-upload',
      headers: {
        token: '', //文件上传请求头
      },
      rules: {
        cardBack: [
          { required: true, message: '请上传课程卡反面', trigger: 'change' },
        ],
        cardFront: [
          { required: true, message: '请上传课程卡正面', trigger: 'change' },
        ],
        centerImg: [
          { required: true, message: '请上传课程卡中心图', trigger: 'change' },
        ],
      },
      img: 'https://xm-evaluate-file.oss-cn-beijing.aliyuncs.com/',
      keid: '',
      total: 0,
      fileList: [],
      fileList: [],
      dataw: {
        bucketId: 4,
        schoolId: '',
        courseType: '',
        tempId: '',
      },
      dats: [],
      schoollist: '',
      schoolType: '',
      template: '',
      checkedKeys: [],
      tableData2: [],
      dialogVisible6: false,
      defaultProps: {
        children: 'childs',
        label: 'nodeName',
      },
      pageNum: 1,
      schoollistsd: [],
      totalCount: 0,
      xinglist: [],
      dialogVisible2: false,
      checkListsd: [],
      xuanlists: [],
      nodeTlist: [],
      subjectId: '',
      liy: [],
      tableData1: [],
      tableData3: [],
      yixuan: [],
      editTableData: [],
      editList: [], //编辑数组
      formData: {
        editList: [],
      },
      courseOfferingStatus: false, //课程配置状态
      myappList: [], //应用列表
      isLast: false, //是否是最后一个配置项
      progressStatusList: [],
    }
  },
  watch: {
    keid() {
      this.curriculumManagelist(this.schoolId)
    },
  },
  methods: {
    //获取配置进度
    async getConfigProgress() {
      //获取学校配置进度
      let { data: res } = await getSchoolConfigStep()
      let progressArr = res.data.cardPrintItemList
      this.progressStatusList = progressArr
      let objIndex = progressArr.findIndex(
        (item) => item.progressItemCode == 'course_view_point'
      )
      console.log('objindex:', objIndex)
      if (objIndex == progressArr.length - 1) {
        this.isLast = true
      }
      progressArr.forEach((item) => {
        switch (item.progressItemCode) {
          case 'create_school_course':
            this.courseOfferingStatus =
              item.progressItemStatus == 0 ? false : true
            break
          default:
            break
        }
      })
    },
    handleChange(list, index) {
      console.log(list, index)
      let obj = this.$refs['cascaderref'][index].getCheckedNodes()
      console.log(obj)
      this.editList[index].leafName = obj[0].label
    },
    xiayibu() {
      let list = []
      for (var i = 0; i < this.xinglist.length; i++) {
        for (var s = 0; s < this.checkListsd.length; s++) {
          if (this.xinglist[i].id == this.checkListsd[s]) {
            this.xinglist[i].nodeid = ''
            list.push(this.xinglist[i])
          }
        }
      }
      this.xuanlists = list
      this.active = 1
    },
    goBack() {
      this.$emit('navlink', 'bazaar_home')
    },
    // changeCss({row, rowIndex,column}){
    //     if(column.label === '课程目标'||column.label === '关键行为'||column.label === '操作'||column.label === '课程卡制作'){
    //         return "yues1sde"
    //     }
    // },//表格样式
    //获取表格数据
    curriculumManagelist(s) {
      let that = this
      let params = {
        curPage: this.curPage,
        pageSize: 10,
        schoolId: s,
        // courseType: this.keid,
      }
      that.tableData = []
      this.spanArr = []
      this.pos = 0
      this.spanArr1 = []
      this.pos1 = 0
      this.spanArr2 = []
      this.pos2 = 0
      homeApi
        .curriculumManagelist(params)
        .then((res) => {
          // that.tableData=res.data.data.dataList
          let list = []
          for (var i = 0; i < res.data.data.dataList.length; i++) {
            if (res.data.data.dataList[i].pointList.length == 0) {
              let li = {
                courseId: res.data.data.dataList[i].courseId,
                cardBack: res.data.data.dataList[i].cardBack,
                centerImg: res.data.data.dataList[i].centerImg,
                cardFront: res.data.data.dataList[i].cardFront,
                courseName: res.data.data.dataList[i].courseName,
                nodeName: res.data.data.dataList[i].nodeName,
                leafName: '',
                pointContent: '',
                id: '',
                templateDetailId: '',
              }
              list.push(li)
            } else {
              for (s = 0; s < res.data.data.dataList[i].pointList.length; s++) {
                let li = {
                  courseId: res.data.data.dataList[i].courseId,
                  cardBack: res.data.data.dataList[i].cardBack,
                  centerImg: res.data.data.dataList[i].centerImg,
                  cardFront: res.data.data.dataList[i].cardFront,
                  courseName: res.data.data.dataList[i].courseName,
                  nodeName: res.data.data.dataList[i].nodeName,
                  leafName: res.data.data.dataList[i].pointList[s].leafName,
                  pointContent:
                    res.data.data.dataList[i].pointList[s].pointContent,
                  id: res.data.data.dataList[i].pointList[s].id,
                  templateDetailId:
                    res.data.data.dataList[i].pointList[s].templateDetailId,
                }
                list.push(li)
              }
            }
          }
          that.tableData = list
          that.editTableData = res.data.data.dataList
          that.getSpanArr(that.tableData)
          that.total = res.data.data.totalCount
        })
        .catch(() => {})
    },
    //获取合并表格条数
    getSpanArr(data) {
      this.spanArr = []
      for (var i = 0; i < data.length; i++) {
        if (i === 0) {
          // 如果是第一条记录（即索引是0的时候），向数组中加入１
          this.spanArr.push(1)
          this.pos = 0
          this.spanArr1.push(1)
          this.pos1 = 0
          this.spanArr2.push(1)
          this.pos2 = 0
        } else {
          if (data[i].courseName === data[i - 1].courseName) {
            // 如果componentType相等就累加，并且push 0  这里是根据一样的componentType匹配
            this.spanArr[this.pos] += 1
            this.spanArr.push(0)
          } else {
            // 不相等push 1
            this.spanArr.push(1)
            this.pos = i
          }
          if (data[i].nodeName === data[i - 1].nodeName) {
            // 如果componentType相等就累加，并且push 0  这里是根据一样的componentType匹配
            this.spanArr1[this.pos1] += 1
            this.spanArr1.push(0)
          } else {
            // 不相等push 1
            this.spanArr1.push(1)
            this.pos1 = i
          }
          if (data[i].templateDetailId === data[i - 1].templateDetailId) {
            // 如果componentType相等就累加，并且push 0  这里是根据一样的componentType匹配
            this.spanArr2[this.pos2] += 1
            this.spanArr2.push(0)
          } else {
            // 不相等push 1
            this.spanArr2.push(1)
            this.pos2 = i
          }
        }
      }
    },
    //合并表格
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      // columnIndex === 0 找到第一列，实现合并随机出现的行数
      if (
        columnIndex == 1 ||
        columnIndex == 4 ||
        columnIndex == 5 ||
        columnIndex == 6
      ) {
        const _row = this.spanArr[rowIndex]
        const _col = _row > 0 ? 1 : 0
        return {
          rowspan: _row,
          colspan: _col,
        }
      }
      if (columnIndex == 0) {
        const _row = this.spanArr1[rowIndex]
        const _col = _row > 0 ? 1 : 0
        return {
          rowspan: _row,
          colspan: _col,
        }
      }
      if (columnIndex == 2) {
        const _row = this.spanArr2[rowIndex]
        const _col = _row > 0 ? 1 : 0
        return {
          rowspan: _row,
          colspan: _col,
        }
      }
    },
    gai(s) {
      this.curPage = s
      this.curriculumManagelist(this.schoolId)
    },
    getSchoolInfo() {
      let that = this
      let params = {
        id: this.schoolId,
      }
      homeApi
        .getSchoolInfo(params)
        .then((res) => {
          if (res.data.data.type == 10) {
            that.keid = 1
          } else {
            that.keid = 3
          }
          that.schoolType = res.data.data.type
          that.schoollist = res.data.data
        })
        .catch(() => {})
    },
    xuan(s) {
      let yue = []
      let ids = []
      for (var i = 0; i < this.tableData.length; i++) {
        if (s == this.tableData[i].courseId) {
          yue.push(this.tableData[i])
          if (this.tableData[i].id !== '') {
            ids.push(this.tableData[i].id)
          }
        }
      }
      this.kexing(s, ids)
    },
    kexing(s, d) {
      this.checkedKeys = d
      this.dialogVisible5 = true
      this.courseId = s
      this.timele1(0, d)
      this.$forceUpdate()
    },
    timele1(s, d) {
      let that = this
      let params = {
        tempId: this.template.id,
        schoolId: 0,
      }
      that.tableData2 = []
      this.liy = []
      this.checkList = []
      homeApi
        .TemplateNodesModel(params)
        .then((res) => {
          that.tableData2 = res.data.data
          that.loading = false
          if (s == 0) {
            that.idkjui(that.tableData2, d)
          } else {
            that.shuxing(that.tableData2)
          }
        })
        .catch(() => {})
    },
    shuxing(s) {
      s.forEach((item) => {
        if (item.childs) {
          if (item.isleaf == 1) {
            item.id = item.id + '0_1'
            item.pointList.forEach((data) => {
              data.nodeName = data.pointContent
              data.isleafs = 0
              // liy.push(data)
            })
            item.childs = item.pointList
            item.disabled = true
          } else {
            item.id = item.id + '0_1'
            item.disabled = true
            this.shuxing(item.childs)
          }
          if (item.isleafs == 0) {
            item.id = item.id + '0_1'
            item.disabled = false
            this.liy.push(item.id)
            console.log(item.id)
          }
        } else {
          item.disabled = true
        }
        this.huise(this.tableData3)
      })
    },
    idkjui(s, d) {
      s.forEach((item) => {
        if (item.childs !== null) {
          if (item.isleaf == 1) {
            item.id = item.id + '0_1'
            item.pointList.forEach((data) => {
              data.nodeName = data.pointContent
              data.isleafs = 0
              // liy.push(data)
            })
            item.childs = item.pointList
            item.disabled = true
          } else {
            item.id = item.id + '0_1'
            item.disabled = true
            this.shuxing(item.childs)
          }
          if (item.isleafs == 0) {
            item.id = item.id + '0_1'
            item.disabled = false
            this.liy.push(item.id)
            console.log(item.id)
          }
        } else {
          item.disabled = true
        }
        this.huises(d)
      })
    },
    huises(d) {
      this.$refs.tree.setCheckedKeys(d)
    },
    huise(s) {
      s.forEach((item) => {
        if (item.childs !== null) {
          if (item.isleaf == 1) {
            for (var i = 0; i < item.pointList.length; i++) {
              this.yixuan.push(item.pointList[i].id)
            }
          } else {
            this.huise(item.childs)
          }
        }
      })
      this.$refs.tree.setCheckedKeys(this.yixuan)
      this.checkedKeys = this.yixuan
    },
    dianjisdf(data, s) {
      this.checkedKeys.push(data.id)
      this.unique(this.checkedKeys)
      console.log(this.checkedKeys)
    },
    unique(arr) {
      for (var i = 0; i < arr.length; i++) {
        for (var j = i + 1; j < arr.length; j++) {
          if (arr[i] == arr[j]) {
            //第一个等同于第二个，splice方法删除第一个
            arr.splice(i, 1)
            i--
          }
        }
      }
      return arr
    },
    getCheckedKeys() {
      let school = this.$refs.tree.getCheckedKeys()
      let that = this
      let schoolVos = []
      let k = 0
      let list = []
      let checkedKeys = that.checkedKeys
      that.checkedKeys.map((train) => {
        checkedKeys.push(train)
      })
      checkedKeys = [...new Set(that.checkedKeys)]
      that.checkedKeys = checkedKeys
      // return false
      for (var i = 0; i < this.checkedKeys.length; i++) {
        for (var s = 0; s < school.length; s++) {
          if (this.checkedKeys[i] == school[s]) {
            list.push(school[s])
          }
        }
      }
      that.loading = true
      for (var i = 0; i < list.length; i++) {
        schoolVos[i] = {
          courseId: that.courseId,
          pointId: list[i],
        }
      }
      homeApi
        .curriculumManagesaveCoursePoints(schoolVos)
        .then((res) => {
          that.loading = false
          that.dialogVisible5 = false
          that.$message({
            message: '添加成功',
            type: 'success',
          })
          //   that.$refs.child1.curriculumManagelist(that.schoolId);
          that.curriculumManagelist(that.schoolId)
        })
        .catch(() => {
          that.loading = false
        })
    },
    timele2() {
      let that = this
      let params = {
        tempId: this.template.id,
        schoolId: that.schoolId,
      }
      that.tableData3 = []
      that.loading = true
      homeApi
        .TemplateNodesModel(params)
        .then((res) => {
          that.tableData3 = res.data.data
          that.loading = false
        })
        .catch(() => {})
    },
    selectCourseActionStore(s, str) {
      console.log(s)
      let that = this
      let subjectId = ''
      this.courseId = s.courseId
      // for (var i = 0; i < this.schoollistsd.length; i++) {
      //   console.log(s.courseName,this.schoollistsd[i].name)
      //   if (this.schoollistsd[i].name == s.courseName) {
      //     subjectId = this.schoollistsd[i].id;
      //   }
      // }
      // return false
      // alert(subjectId)
      // this.subjectId = subjectId;
      let params = {
        // subjectId: subjectId,
        courseId: s.courseId,
        pageNum: this.pageNum,
        pageSize: 10,
      }
      that.loading = true
      homeApi
        .selectCourseActionStore(params)
        .then((res) => {
          that.loading = false
          that.xinglist = res.data.data.dataList
          that.totalCount = res.data.data.totalCount
          if (str == 'edit') {
            this.editDialogVisible = true
          } else {
            that.dialogVisible2 = true
          }
        })
        .catch(() => {})
    },
    editKeyPoints(row) {
      console.log(row)
      this.editDialogVisible = true
      this.courseId = row.courseId
      let obj = this.editTableData.find((item) => item.courseId == row.courseId)
      console.log(obj)
      this.editList = obj.pointList
      this.formData.editList = obj.pointList
    },
    getSubjectList() {
      let that = this
      let params = {
        schoolId: this.schoolId,
      }
      that.loading = true
      homeApi
        .getSubjectList(params)
        .then((res) => {
          that.loading = false
          that.schoollistsd = res.data.data
        })
        .catch(() => {})
    },
    timeles() {
      let that = this
      let params = {
        tempId: this.template.id,
        schoolId: 0,
      }
      homeApi
        .TemplateNodesModel(params)
        .then((res) => {
          that.shuzubianl(res.data.data)
          let arr = res.data.data
          this.formatData(arr)
          that.nodeTlist = arr
        })
        .catch(() => {})
    },
    formatData(data) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].children.length < 1) {
          data[i].children = undefined
        } else {
          this.formatData(data[i].children)
        }
      }
    },
    shuzubianl(arr) {
      let that = this
      arr.forEach((res) => {
        res.children = res.childs
        res.value = res.id
        res.label = res.nodeName
        if (res.childs && res.childs.length > 0) {
          that.shuzubianl(res.childs)
        }
      })
    },
    insertCourseAction() {
      let that = this
      let courseActionVoList = []
      console.log(that.xuanlists)
      for (var i = 0; i < this.xuanlists.length; i++) {
        that.idhui(
          that.nodeTlist,
          that.xuanlists[i].nodeid[that.xuanlists[i].nodeid.length - 1],
          i
        )
        let list = {
          leafName: that.xuanlists[i].leafName,
          pointContent: that.xuanlists[i].pointContent,
          templateDetailId:
            that.xuanlists[i].nodeid[that.xuanlists[i].nodeid.length - 1],
          courseId: that.courseId,
          courseActionStoreId: that.xuanlists[i].id,
        }
        courseActionVoList.push(list)
      }
      let params = {
        courseActionVoList: courseActionVoList,
      }
      homeApi
        .insertCourseAction(params)
        .then((res) => {
          if (res.data.code == 0) {
            that.$message({
              message: '保存成功',
              type: 'success',
            })
            that.dialogVisible2 = false
            that.curriculumManagelist(this.schoolId)
          } else {
            that.$message(res.data.msg)
          }
        })
        .catch(() => {})
    },
    //删除一条行为
    delItem(index) {
      this.editList.splice(index, 1)
    },
    editSave() {
      let that = this
      console.log(this.editList)
      let courseActionVoList = []
      for (var i = 0; i < this.formData.editList.length; i++) {
        // that.editIdhui(that.nodeTlist, that.editList[i].nodeid[that.editList[i].nodeid.length-1],i)
        let list = {
          leafName: that.formData.editList[i].leafName,
          pointContent: that.formData.editList[i].pointContent,
          templateDetailId: that.formData.editList[i].templateDetailId,
          courseId: that.courseId,
          // courseActionStoreId:that.editList[i].id
        }
        courseActionVoList.push(list)
      }
      console.log(courseActionVoList)
      const isEmpty = courseActionVoList.some((item) => !item.leafName)
      if (isEmpty) {
        return resetMessage({
          type: 'info',
          message: `课程目标不能为空!`,
        })
      }
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          let params = {
            schoolCoursePoints: courseActionVoList,
          }
          saveCourseBehaviorAndTarget(params)
            .then((res) => {
              if (res.data.code == 0) {
                that.$message({
                  message: '保存成功',
                  type: 'success',
                })
                this.editDialogVisible = false
                that.curriculumManagelist(this.schoolId)
              } else {
                that.$message(res.data.msg)
              }
            })
            .catch(() => {})
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    idhui(s, d, z) {
      s.forEach((item) => {
        //   console.log(item.id,d)
        if (item.id == d) {
          this.xuanlists[z].leafName = item.nodeName
        } else {
          if (item.childs && item.childs.length > 0) {
            this.idhui(item.childs, d, z)
          }
        }
      })
    },
    editIdhui(s, d, z) {
      console.log(s, d, z)
      s.forEach((item) => {
        //   console.log(item.id,d)
        if (item.id == d) {
          this.editList[z].leafName = item.nodeName
        } else {
          if (item.childs && item.childs.length > 0) {
            this.editIdhui(item.childs, d, z)
          }
        }
      })
    },
    curriculumManagecoursePointexport() {
      let that = this
      var url = homeApi.curriculumManagecoursePointexport
      var xhr = new XMLHttpRequest()
      xhr.open(
        'GET',
        url + '?schoolId=' + that.schoolId + '&courseType=' + that.keid
      )
      xhr.setRequestHeader('token', localStorage.getItem('token'))
      xhr.responseType = 'blob' // 设置返回类型blob
      xhr.onload = function () {
        if (this.status === 200) {
          var blob = this.response
          var reader = new FileReader()
          reader.readAsDataURL(blob) // 转换为base64，可以直接放入a标签href

          reader.onload = function (e) {
            // 转换完成后创建a标签下载
            var a = document.createElement('a')
            a.download = '课程行为.xlsx'
            a.href = e.target.result
            a.click()
          }
          that.loading = false
          that.$message({
            message: '下载成功',
            type: 'success',
          })
        } else {
          that.$message('下载失败')
          that.loading = false
        }
      }
      xhr.send()
    },
    shangchaun() {
      this.dataw.schoolId = this.schoolId
      this.dataw.courseType = this.keid
      this.dataw.tempId = this.template.id
    },
    urlslist() {
      return homeApi.curriculumport
    },
    submitUpload() {
      this.$refs.upload.submit()
    },
    curriculumManagedownloadtemplate() {
      let that = this
      var url = homeApi.curriculumManagedownloadtemplate
      var xhr = new XMLHttpRequest()
      xhr.open('GET', url)
      xhr.setRequestHeader('token', localStorage.getItem('token'))
      xhr.responseType = 'blob' // 设置返回类型blob
      xhr.onload = function () {
        if (this.status === 200) {
          var blob = this.response
          var reader = new FileReader()
          reader.readAsDataURL(blob) // 转换为base64，可以直接放入a标签href
          reader.onload = function (e) {
            // 转换完成后创建a标签下载
            var a = document.createElement('a')
            a.download = '课程行为模板.xlsx'
            a.href = e.target.result
            a.click()
          }
          that.loading = false
          that.$message({
            message: '下载成功',
            type: 'success',
          })
        } else {
          that.$message('下载失败')
          that.loading = false
        }
      }
      xhr.send()
    },
    chengg(data) {
      console.log(data)
      if (data.code == '0') {
        this.dats = data.data
        this.dialogVisible6 = true
      } else {
        this.$message({
          message: data.msg,
          type: 'success',
        })
      }
    },
    publishCourseEvaPoint() {
      let that = this
      let params = {
        schoolId: this.schoolId,
      }
      homeApi
        .publishCourseEvaPoint(params)
        .then((res) => {
          that.$message({
            message: '发布成功',
            type: 'success',
          })
          that.curriculumManagelist(that.schoolId)
        })
        .catch(() => {})
    },
    //上一步或下一步
    handlePreOrNext(index) {
      console.log(this.tableData)
      if (index == 3) {
        const isEmpty = this.tableData.some((item) => !item.leafName)
        const obj = this.tableData.find((item) => !item.leafName)
        console.log(obj)
        if (isEmpty) {
          return resetMessage({
            type: 'info',
            message: `${obj.nodeName}/${obj.courseName}课程未配置课程目标!`,
          })
        }
        saveCourseObservations()
          .then((res) => {
            if (res.data.code == '0') {
              this.$emit('prevOrNext', index)
            } else {
              resetMessage({
                type: 'error',
                message: res.data.msg,
              })
            }
          })
          .catch((err) => {
            console.log(err)
          })
      } else {
        this.$emit('prevOrNext', index)
      }
    },
    //跳转课程开设
    goClass() {
      let token = localStorage.getItem('token')
      let roleId = localStorage.getItem('roleId')
      let obj = this.myappList.find((item) => item.appId == 14)
      window.open(obj.appUrl + 'zpcourse?token=' + token + '&roleId=' + roleId)
    },
    // 获取我的应用列表
    async getMyappList() {
      if (!this.roleId) {
        this.roleId = -1003
      }
      const { data: res } = await getMyappList({
        roleId: this.roleId,
      })
      console.log('应用列表', res.data)
      this.myappList = res.data
    },
    //添加一条行为
    addBehavior() {
      this.editList.push({
        pointContent: '',
        nodeid: '',
      })
    },
    //获取学校信息
    async usercenterinfo() {
      const { data: res } = await usercenterinfo()
      this.schoolId = res.data.schoolId
    },
  },
  created() {
    // this.usercenterinfo()
  },
  async mounted() {
    // this.schoolId = localStorage.getItem("schoolIds");
    const { data: ressc } = await usercenterinfo()
    this.schoolId = ressc.data.schoolId
    let { data: res } = await getSchoolTemplateMsg({ courseTypeId: 0 })
    this.template = res.data
    this.getSchoolInfo()
    this.headers.token = localStorage.getItem('token')
    this.timele2()
    this.getSubjectList()
    this.timeles()
    this.getMyappList()
    this.getConfigProgress()
  },
}
</script>

<style scoped lang="less">
/deep/ .el-dialog__header {
  padding-bottom: 10px;
}
/deep/ .el-dialog__body {
  padding-top: 0;
}
.tips_text {
  color: red;
  // padding-left: 5px;
  margin-bottom: 10px;
}
/deep/ .el-form-item {
  margin-bottom: 0;
}
.add_calss {
  font-weight: bold;
  margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/bench/components/observation.vue